import React, { useEffect, useState } from "react";
import Hero from "../../components/Hero/Hero";
import BlogPreview from "../../components/BlogPreview/BlogPreview";
import ContactForm from "../../components/ContactForm/ContactForm";
import Footer from "../../components/Footer/Footer";
import CharacterCard from "../../components/CharacterCard/CharacterCard";

const useBlogPosts = () => {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/postsManifest.json")
      .then((res) => res.json())
      .then((data) => {
        setPosts(data.sort((a, b) => b.date.localeCompare(a.date)));
      });
  }, []);
  return posts;
};

const Home = () => {
  const posts = useBlogPosts();
  return (
    <>
      <Hero />
      <CharacterCard />
      <BlogPreview
        posts={posts.slice(0, 2)}
        showDiscoverAll
        title="📜 Latest Scrolls"
      />
      <ContactForm />
      <Footer />
      <style jsx>{`
        .discover-scrolls-link {
          display: inline-block;
          margin-top: 0.5rem;
          font-size: 1.15rem;
          color: var(--accent);
          background: var(--panel);
          border: 2px solid var(--scroll);
          border-radius: 8px;
          padding: 0.5em 1.2em;
          text-decoration: none;
          font-family: "IM Fell English SC", serif;
          transition: background 0.2s, color 0.2s, box-shadow 0.2s;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }
        .discover-scrolls-link:hover {
          background: var(--accent);
          color: var(--panel);
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
        }
      `}</style>
    </>
  );
};

export default Home;
